module.exports = __webpack_public_path__ + "img/health-condition-colored.696228b1.svg";